import React from 'react';

import BottomPopupDropdownOptions from '@/components/BottomPopupDropdownOptions';

const BottomPopup = ({
	selectedProducts,
	designList,
	onActionClick,
	isUnSelectAll,
	getRemainingStyles,
	setIsShowPublishDesign,
	handleDownload,
	clearSelection,
	onBulkFavourite
}) => {
	return (
		<div className="design-count-section design-list-count bg-white shadow-8dp">
			<div className="count-info d-flex justify-content-between align-items-center">
				<div className="design-count">
					<p className="semibold-18">{`${selectedProducts?.length}/${designList?.totalElements}`}</p>
				</div>
				{!isUnSelectAll && (
					<>
						<button
							className="button text size36 px-0"
							onClick={(e) => {
								e.stopPropagation();
								onActionClick('SELECT_ALL');
							}}
						>
							<span className="ml-1">Select 1st {designList?.data?.length} Styles</span>
						</button>
						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
					</>
				)}
				{isUnSelectAll && (
					<>
						<button
							className="button text size36"
							onClick={() => onActionClick('FETCH_NEXT_PAGE')}
							disabled={getRemainingStyles() === 0}
						>
							<span className="ml-1">Select Next {getRemainingStyles()} Styles</span>
						</button>
						<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
							|
						</span>
					</>
				)}

				<div className="buttons" onClick={() => setIsShowPublishDesign(true)}>
					<button className="button text size36">
						<span className="ml-1">Publish</span>
					</button>
				</div>
				<div className="buttons" onClick={onBulkFavourite}>
					<button className="button text size36">
						<span className="ml-1">Add to Favourite</span>
					</button>
				</div>
				<div>
					<BottomPopupDropdownOptions
						onActionClick={handleDownload}
						options={[
							{
								id: 'DOWNLOAD_REPORT',
								title: 'Techpack Summary',
								value: 'DOWNLOAD_REPORT'
							}
						]}
					/>
				</div>

				<div className="text-right close-icon" onClick={clearSelection}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
					>
						<path
							d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
							fill="#6A7181"
						/>
					</svg>
				</div>
			</div>
		</div>
	);
};

export default BottomPopup;
